<div class="flex w-102.75">
    <section class="w-full">
        <article id="header" class="flex bg-primary-green-2 rounded-ss-lg rounded-se-lg">
            <div class="flex flex-1 min-w-0 ml-5 my-4 items-center">
                <img [src]="images.arrowLeft" alt="back" (click)="close.emit()" class="h-6 w-6 cursor-pointer" />
                <div class="ml-5">
                    <h1 class="font-bold text-[22px] text-primary-purple">{{ literalService.get('services.routes.title', true) }}</h1>
                </div>
            </div>
            <div class="flex shrink-0 items-center mr-6 gap-3">
                <img [src]="images.services.routes.settings" alt="multiConfig" class="w-6 h-6 cursor-pointer" (click)="openMultiConfig()" [tooltip]="literalService.get('services.routes.multiConfig.tooltip', true)" [position]="TooltipPosition.ABOVE" />
                <img [src]="images.services.routes.reorganize" alt="reorganize" class="w-6 h-6 cursor-pointer" (click)="reorganizeEventEmitter.emit()" [tooltip]="literalService.get('services.routes.reorganize.tooltip', true)" [position]="TooltipPosition.ABOVE" />
                <img [src]="images.services.routes.addRoute" alt="addRoute" class="w-6 h-6 cursor-pointer" (click)="createNewRoute()" [tooltip]="literalService.get('services.routes.tooltips.newRoute', true)" [position]="TooltipPosition.ABOVE" />
            </div>
        </article>
        <article id="search" class="flex bg-white">
            <div class="mx-5 my-4 items-center w-full">
                <app-service-routes-search-bar
                    [placeholder]="literalService.get('services.routes.search', true)"
                    [searching]="searching"
                    (searchEventEmitter)="search($event)">
                </app-service-routes-search-bar>
            </div>
        </article>
        <article id="body" class="flex bg-white">
            <div class="mx-5 my-5 items-center w-92.75">
                @if (!routes()?.isFetchingServices) {
                    @for (route of this.routes()!.value; track $index) {
                        <div class="row">
                            <app-service-routes-row [route]="route" [serviceInfoRoutesSelected]="serviceInfoRoutesSelected()" [routeSelected]="routeSelected()" [index]="$index" (selectRoute)="selectRoute.emit($event)" (hideRoute)="hideRoute($event)" (designRoute)="designRoute.emit($event)"></app-service-routes-row>
                        </div>
                    }
                } @else {
                    <ngx-skeleton-loader [count]="routes()?.pagination?.numberOfElements || 5" appearance="line" [theme]="{ 'height.px': 50, 'margin-bottom': '4px' }"></ngx-skeleton-loader>
                }
            </div>
        </article>
        <article id="footer" class="flex items-center bg-white rounded-es-lg rounded-ee-lg pb-17.5">
            <app-pagination id="routesPagination" [id]="'routesPagination'" class="mx-5" [pagination]="routes()?.pagination" [loading]="!!routes()?.isFetchingServices && !routes()?.pagination?.totalPages" [baseUrl]="'/services'" (changePage)="changePageRoutes($event)" [small]="true" [maxLength]="5" [right]="false" />
        </article>
    </section>
</div>
  